var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.787,
    height: 96.5,
    viewBox: "0 0 98.787 96.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "userIcon",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_656",
    "data-name": "Ellipse 656",
    cx: 48.894,
    cy: 47.75,
    rx: 48.894,
    ry: 47.75,
    transform: "translate(0 0)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(26.313 20.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M-536.406-79.21h-2.831c-8.646,0-21.054,5.7-21.054,15.238a4.506,4.506,0,0,0,4.065,4.935c.086.009.172.016.258.02H-519.5a4.45,4.45,0,0,0,4.336-4.572q0-.1-.013-.2v-.184C-515.175-73.508-527.582-79.21-536.406-79.21Z",
    transform: "translate(560.319 114.09)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M-532.534-103.437a10.773,10.773,0,0,0,8.074-3.305c5.262-5.14,5.077-14.688,5.077-15.053a13.008,13.008,0,0,0-13.16-12.852A13.008,13.008,0,0,0-545.7-121.8c0,.368-.189,9.913,5.077,15.238A11.355,11.355,0,0,0-532.534-103.437Z",
    transform: "translate(555.12 134.647)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.9480ea23c77fb9b8f4e7f1a81c1124a9.svg";
export { ForwardRef as ReactComponent };